import { isInitialized } from '@Containers/InitContainer';
import FrameContainer from '@Containers/Layout/FrameContainer';
import { isLoggedIn } from '@Containers/SessionContainer';
import { RouteErrorHandler } from '@Core/AppErrorHandler';
import routes from '@Core/config/routes';
import Loader from '@Core/Loader';
import React from 'react';
import { createBrowserRouter, redirect, RouterProvider } from "react-router";

const router = createBrowserRouter([
    {
        path: '/',

        errorElement: <RouteErrorHandler />,

        HydrateFallback: Loader,

        loader: async ({ request }) => {
            await isInitialized();

            if (!isLoggedIn()) {
                if (!request.url.match(/\/login$/)) {
                    return redirect('/login');
                }
            } else {
                if (request.url.match(/\/login$/)) {
                    return redirect('/');
                }
            }
        },

        Component: FrameContainer,

        children: routes,
    },
]);

export default function RouterContainer() {
    return (
        <RouterProvider router={router} />
    );
}
